import { Button, Card, Checkbox } from "antd";
import { getInfoOverQuota } from "api";
import DashboardPageHeader from "components/dashboard-header/DashboardPageHeader";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { setInfoOverQuota } from "redux/slices/infoOverQuota";
import { convertIDR, formatNumberWithDot } from "utils/helpers";
import useDocumentTitle from "utils/useDocumentTitle";
import "./overusage-confirmation.less";
import ModalConfirm from "components/popups/modal/ModalConfirm";
import { WarningOverQuota } from "../../main/alert/OverQouta";

const OverusageConfirmation = () => {
  useDocumentTitle("Confirmation");
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const [checked, setChecked] = useState(false);

  const toggleCheck = () => setChecked((prev) => !prev);

  // Per-customer overquota rate comes from the backend (info-over-quota), so the
  // figure shown here always matches the invoice. See build/OVERQUOTA_RATE_BACKEND_REQUEST.md.
  const infoQuota = useSelector(({ infoOverQuota }) => infoOverQuota.value);

  const getInfoQuota = useCallback(async () => {
    const { data } = await getInfoOverQuota();
    dispatch(setInfoOverQuota(data));
  }, [dispatch]);

  useEffect(() => {
    if (!infoQuota) getInfoQuota();
  }, [infoQuota, getInfoQuota]);

  // Build the rate line from the numeric fields (not the backend's convenience label).
  // Fallback keeps the page safe if the fields aren't present yet (e.g. FE deployed
  // before backend #117) — never show a wrong fixed number.
  const rateText =
    infoQuota && infoQuota.overQuotaUnitPrice
      ? `${convertIDR(infoQuota.overQuotaUnitPrice)} per ${formatNumberWithDot(
          infoQuota.overQuotaUnitSize
        )} kiriman email`
      : null;

  const handleConfirm = () => {
    ModalConfirm({
      title: "Apakah Anda yakin ingin menggunakan over quota?",
      customMessage: (
        <div>
          <p className="mb-6">
            Anda akan dikenakan biaya tambahan sesuai dengan penggunaan email berlebih yang
            dikirimkan.
            <br /> <br /> Akun anda akan diaktifkan kembali dan dapat mengirimkan email setelah
            melakukan konfirmasi tersebut.
          </p>
        </div>
      ),
      okText: "Ya, Lanjutkan",
      cancelText: "Batalkan",
      onOk: () => {
        navigate("/overusage/process");
      },
    });
  };

  return (
    <div className="OverusageConfirmation">
      <DashboardPageHeader title="Over Quota Usage" backPath={location.state?.referrer} />
      <div className="flex flex-col px-6 pt-3 gap-y-6">
        <WarningOverQuota />
        <Card className="OverusageConfirmation__card" title="Konfirmasi Over Quota Usage">
          <div className="OverusageConfirmation__body">
            <p>
              Dengan melakukan konfirmasi penggunaan kelebihan kuota layanan tersebut, berarti
              pelanggan setuju dengan ketentuan berikut:
            </p>
            <ul>
              <li>
                Layanan akan diaktifkan kembali (unsuspend) dan pelanggan dapat menggunakan layanan
                serta mengirimkan email kembali
              </li>
              <li>
                Pelanggan akan dikenakan biaya kelebihan penggunaan (over usage) sesuai dengan
                jumlah kuota berlebih yang digunakan
              </li>
              <li>
                {rateText
                  ? `Biaya kelebihan penggunaan email tersebut yakni sebesar ${rateText}`
                  : "Biaya kelebihan penggunaan email akan dihitung sesuai paket over quota layanan Anda"}
              </li>
              <li>Tagihan akan dikirimkan diakhir periode kuota dari layanan tersebut</li>
              <li>Pelanggan wajib melakukan pembayaran tagihan kelebihan kuota tersebut</li>
              <li>
                Apabila pelanggan tidak kunjung membayar tagihan setelah tanggal jatuh tempo, maka
                layanan akan terkena suspend
              </li>
            </ul>
          </div>
          <div className="flex flex-col items-start gap-y-1">
            <Checkbox
              className="text-secondary"
              onChange={toggleCheck}
              checked={checked}
              defaultChecked={checked}>
              Saya telah membaca dan menyetujui ketentuan diatas
            </Checkbox>
            <Button type="primary" disabled={!checked} className="ml-auto" onClick={handleConfirm}>
              Konfirmasi & Lanjutkan
            </Button>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default OverusageConfirmation;
